import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import './GlobalDisclaimer.scss';

const GlobalDisclaimer = ({ ui }) => {
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const [disclaimerText, setDisclaimerText] = useState(ui.globalDisclaimer);

  const updateDisclaimer = () => {
    const selectedSubmenuId =
      window.selectedConfig && window.selectedConfig.currentSelectedSubmenu;

    // ✅ CHANGED: use currentSelectedAccordion instead of selectedAccordion
    // (currentSelectedAccordion persists even after collapse, selectedAccordion doesn't)
    const selectedAccordionId =
      window.selectedConfig && window.selectedConfig.currentSelectedAccordion
        ? window.selectedConfig.currentSelectedAccordion.replace("accordion_", "")
        : null;

    const selectedHotspotId =
      window.selectedConfig && window.selectedConfig.currentSelectedHotspot;

    let show = false;
    let text = '';

    const allSubmenu =
      window.config && window.config.allSubmenu
        ? window.config.allSubmenu
        : [];

    const menuList =
      window.selectedConfig && window.selectedConfig.menuList
        ? window.selectedConfig.menuList
        : [];

    // 1️⃣ HOTSPOT HAS HIGHEST PRIORITY
    if (selectedHotspotId) {
      let hotspotFound = false;

      for (const sub of allSubmenu) {
        const hotspot =
          sub.hotspotDataInfo &&
          sub.hotspotDataInfo.find(h => h.hsname === selectedHotspotId);

        if (hotspot) {
          show = hotspot.showGlobalDisclaimer !== false;
          text = hotspot.disclaimerText || ui.globalDisclaimer;
          hotspotFound = true;
          break;
        }
      }

      if (!hotspotFound) {
        show = false;
        text = '';
      }
    }

    // 2️⃣ SUBMENU IF NO HOTSPOT (only when a real submenu, different from accordion, is selected)
    else if (selectedSubmenuId && selectedSubmenuId !== selectedAccordionId) {
      let item = allSubmenu.find(
        sub => sub.id === selectedSubmenuId
      );

      // If not a submenu, check popup buttons
      if (!item) {
        for (const sub of allSubmenu) {
          const popup =
            sub.popupBoxButtons && sub.popupBoxButtons.length
              ? sub.popupBoxButtons[0]
              : null;

          if (popup && popup.firstButton && popup.firstButton.id === selectedSubmenuId) {
            item = popup.firstButton;
            break;
          }

          if (popup && popup.secondButton && popup.secondButton.id === selectedSubmenuId) {
            item = popup.secondButton;
            break;
          }
        }
      }

      if (item) {
        show = item.showGlobalDisclaimer !== false;
        text = item.disclaimerText || ui.globalDisclaimer;
      }
      // ✅ NEW: agar submenu item nahi mila (matlab ye actually accordion id tha),
      // to accordion-level disclaimer par fallback karo instead of hiding
      else if (selectedAccordionId) {
        const accordion = menuList.find(acc => acc.id === selectedAccordionId);
        if (accordion) {
          show = accordion.showGlobalDisclaimer !== false;
          text = accordion.disclaimerText || ui.globalDisclaimer;
        } else {
          show = true;
          text = ui.globalDisclaimer;
        }
      }
    }

    // 3️⃣ ACCORDION ONLY (submenu === accordion, matlab koi specific submenu click nahi hua)
    else if (selectedAccordionId) {
      const accordion = menuList.find(
        acc => acc.id === selectedAccordionId
      );

      if (accordion) {
        show = accordion.showGlobalDisclaimer !== false;
        text = accordion.disclaimerText || ui.globalDisclaimer;
      } else {
        show = true;
        text = ui.globalDisclaimer;
      }
    }

    // 4️⃣ ONLOAD / FALLBACK
    else {
      show = true;
      text = ui.globalDisclaimer;
    }

    setShowDisclaimer(show);
    setDisclaimerText(text);
  };

  useEffect(() => {
    const interval = setInterval(updateDisclaimer, 200);
    return () => clearInterval(interval);
  }, []);

  if (!showDisclaimer) return null;

  return ReactDOM.createPortal(
    <div id="disclaimer">
      {disclaimerText}
    </div>,
    document.getElementById("globaDisclaimer")
  );
};

export default GlobalDisclaimer;